<div class="modal__header">
	<h2 class="title" id="modal__title">{{ 'modals.busTrip.title.travelTo' | ibeadmin: 'sync' }} {{ busStopLocation }}</h2>
	<div class="modal__header-actions">
		<button attr.aria-label="{{ 'modals.busTrip.aria.closeDialog' | ibeadmin: 'sync' }}" (click)="cancel()">
			<app-svg svg="icons.svg#general--close" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	<p>{{ 'modals.busTrip.text.partOfYourTrip' | ibeadmin: 'sync' }}</p>
	<ng-container *ngIf="!allSingleStop">
		<p>{{ 'modals.busTrip.text.chooseHopOff' | ibeadmin: 'sync' }} {{ busStopLocation }} {{ 'modals.busTrip.text.chooseHopOffNearby' | ibeadmin: 'sync' }}.</p>
		<form [formGroup]="form">
			<div class="form-field--row grid no-padding">
				<div class="form-field col-6 col-tp-6 col-p-12" *ngFor="let booking of stops; let flightIndex = index" formArrayName="stops">
					<ng-container [formGroupName]="flightIndex">
						<label class="label">{{INDRA_getCity(flightIndex)}} </label>
						<app-select-input 
							[parentForm]="form.get('stops').at(index)" 
							formControlName="hopOff" 
							[inputOptions]="optionsHopOff[flightIndex]"
							[id]="'hopOff-' + flightIndex"
							[required]="true" 
							[errorMessage]="'Field is required'" 
							[placeholder]="INDRA_getPlaceholder(flightIndex)">
						</app-select-input>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="!form.controls['stops'].controls[flightIndex].valid&&triedToSubmit">{{ 'modals.busTrip.text.fieldRequired' | ibeadmin: 'sync' }}
						</span>
					</ng-container>
				</div>
			</div>
		</form>
		<div class="top-gap">
			<p class="muted-light">{{ 'modals.busTrip.text.youCan' | ibeadmin: 'sync' }} <a class="link" href="{{INDRA_getBusScheduleURL()}}" attr.aria-label="{{ 'modals.busTrip.aria.checkSchedule' | ibeadmin: 'sync' }}"  target="_blank">{{ 'modals.busTrip.text.checkSchedule' | ibeadmin: 'sync' }}</a> {{ 'modals.busTrip.text.ofTheBus' | ibeadmin: 'sync' }}</p>
		</div>
	</ng-container>
	<ng-container *ngIf="allSingleStop">
		<p>{{ 'modals.busTrip.text.hoppingOnOffBus' | ibeadmin: 'sync' }}</p>
		<div class="grid no-padding">
			<div class="col-6 col-tp-6 col-p-12" *ngFor="let stop of singleBusStopDetails; let stopIndex = index">
				<label class="label">{{INDRA_getCity(stopIndex)}} </label>
				<p class="bold"> {{ INDRA_displayHopLabel(stop, 'on') }} </p>
				<br>
				<p>{{ 'modals.busTrip.text.busDropsYou' | ibeadmin: 'sync' }}</p>
				<p class="bold">{{ INDRA_displayHopLabel(stop, 'off') }}</p>
			</div>
		</div>
	</ng-container>
</div>
<div class="modal__footer">
	<div class="modal__footer-action positive-action"><button class="button button-accent"
			(click)="confirm()">{{ 'modals.busTrip.text.done' | ibeadmin: 'sync' }}</button>
	</div>
</div>
